import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../../Buttons/StatusBadgeWithDropdown';

const data = [
    {
        materialNumber: '--',
        shortDescription: '--',
        materialGroup: '--',
        materialCategory: '--',
        materialTypeCode: '--',
        storageType: '--',
        baseUOM: '--',
        weightUOM: '--',
        grossWt: '--',
        netWt: '--',
        sizeUOM: '--',
        length: '--',
        width: '--',
        height: '--',
        unspscCode: '--',
        manufacturerPartCode: '--',
        criticalPartIndicator: '--',
        hazMaterialNumber: '--',
        iuid: '--',
        legacyNumber: '--',
        createDateOfMaterial: '--',
        Status: 'Active',
    },
];

const columns = [
    { id: 'materialNumber', label: 'MATERIAL NUMBER', align: 'left', minWidth: '180px' },
    { id: 'shortDescription', label: 'SHORT DESCRIPTION', align: 'left', minWidth: '200px' },
    { id: 'materialGroup', label: 'MATERIAL GROUP', align: 'left', minWidth: '180px' },
    { id: 'materialCategory', label: 'MATERIAL CATEGORY', align: 'left', minWidth: '200px' },
    { id: 'materialTypeCode', label: 'MATERIAL TYPE CODE', align: 'left', minWidth: '200px' },
    { id: 'storageType', label: 'STORAGE TYPE', align: 'left', minWidth: '150px' },
    { id: 'baseUOM', label: 'BASE UOM', align: 'left', minWidth: '120px' },
    { id: 'weightUOM', label: 'WEIGHT UOM', align: 'left', minWidth: '150px' },
    { id: 'grossWt', label: 'GROSS WT', align: 'left', minWidth: '120px' },
    { id: 'netWt', label: 'NET WT', align: 'left', minWidth: '120px' },
    { id: 'sizeUOM', label: 'SIZE UOM', align: 'left', minWidth: '120px' },
    { id: 'length', label: 'LENGTH', align: 'left', minWidth: '120px' },
    { id: 'width', label: 'WIDTH', align: 'left', minWidth: '120px' },
    { id: 'height', label: 'HEIGHT', align: 'left', minWidth: '120px' },
    { id: 'unspscCode', label: 'UNSPSC CODE', align: 'left', minWidth: '180px' },
    { id: 'manufacturerPartCode', label: 'MANUFACTURER PART CODE', align: 'left', minWidth: '250px' },
    { id: 'criticalPartIndicator', label: 'CRITICAL PART INDICATOR', align: 'left', minWidth: '220px' },
    { id: 'hazMaterialNumber', label: 'HAZ MATERIAL NUMBER', align: 'left', minWidth: '200px' },
    { id: 'iuid', label: 'IUID', align: 'left', minWidth: '100px' },
    { id: 'legacyNumber', label: 'LEGACY NUMBER', align: 'left', minWidth: '200px' },
    { id: 'createDateOfMaterial', label: 'CREATE DATE OF MATERIAL', align: 'left', minWidth: '220px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '150px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const MaterialMasterBasicTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                    {column.label}
                                    {column.sortable !== false && (
                                        <IconButton
                                            size="small"
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            <img src={SortIcon} alt="Sort" />
                                        </IconButton>
                                    )}
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((customer) => (
                        <TableRow key={customer.id}>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                    {column.id === 'Status' ? (
                                        <span
                                            className={`status-badge ${customer.Status === 'Active' ? 'complete-status no-dropdown-badge' : 'cancel-status no-dropdown-badge'}`}
                                        >
                                            {customer.Status}
                                        </span>
                                    ) : column.id === 'action' ? (
                                        <SbActionDropdownButton
                                            options={[{ type: 'Edit' }, { type: 'View' }]}
                                            openAddModal={props.handleOpenModal}
                                            addBulkModel={props.handleOpenViewModal}
                                        />
                                    ) : (
                                        customer[column.id]
                                    )}
                                </TableCell>

                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                    Ascending to Descending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                    Descending to Ascending
                </MenuItem>
            </Menu>
        </TableContainer>
    );
};

export default MaterialMasterBasicTable;
